import { z } from 'zod'
import { userMediaSchema } from '../shared/userMedia'

export const profileMediaSchema = z.object({
  avatar_media: userMediaSchema,
  sticker_media: userMediaSchema.nullable()
})

export const profileGetResponseSchema = z.object({
  account: z.string(),
  join_date: z.string(),
  chain_url: z.string(),
  is_owner: z.boolean(),
  kyc_completed: z.boolean(),
  media: profileMediaSchema,

  stat: z.object({
    user: z.object({
      mythic: z.number().optional(),
      grail: z.number().optional(),
      legendary: z.number().optional(),
      ultra: z.number().optional(),
      redeemed: z.number().optional(),
      royalty_set: z.number().optional()
    })
  })
})

export type ProfileMediaSchema = z.infer<typeof profileMediaSchema>

export type ProfileGetResponse = z.infer<typeof profileGetResponseSchema>
